import api from '@pray/shared/utils/api';

/**
 * Get giving subscription retention cohort data for an artist.
 *
 * For the Pray.com artist (artist._id === 1), returns platform-wide data
 * across all artists.
 *
 * @param {Object} params
 * @param {string} params.artistId - The artist UUID
 * @param {string} [params.startDate] - Start date ISO string
 * @param {string} [params.endDate] - End date ISO string
 * @param {string} [params.interval] - Interval: 'week', 'month'
 * @param {number} [params.maxCohortAge] - Max number of periods to track
 * @returns {Promise<Object>} Retention cohort data
 */
export async function getGivingRetention({ artistId, startDate, endDate, interval = 'month', maxCohortAge = 12 }) {
  const params = new URLSearchParams();

  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  if (interval) params.append('interval', interval);
  if (maxCohortAge) params.append('max_cohort_age', String(maxCohortAge));

  const queryString = params.toString();
  const url = `/web/studio/artists/${artistId}/givingPayments/retention${queryString ? `?${queryString}` : ''}`;

  const response = await api.get(url);
  return response.data;
}
